import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: '¿Cómo recibo el acceso?',
      answer: 'Recibirás el acceso de forma instantánea después de completar tu pago. Te enviaremos un correo electrónico con tus credenciales de acceso y podrás comenzar a usar Nexus Digital Intelligence inmediatamente. No hay tiempos de espera ni aprobaciones manuales. En menos de 5 minutos estarás dentro de la plataforma explorando todos los módulos y herramientas.'
    },
    {
      question: '¿Es para principiantes o necesito experiencia previa?',
      answer: 'Nexus está diseñado específicamente para que cualquier persona pueda usarlo, sin importar su nivel de experiencia. No necesitas conocimientos técnicos, ni experiencia en marketing digital, ni habilidades de diseño. Nuestra Inteligencia Artificial hace todo el trabajo pesado por ti: analiza mercados, genera creativos profesionales y te entrega estrategias listas para implementar. Incluimos tutoriales paso a paso y una interfaz tan intuitiva que estarás generando resultados desde el primer día.'
    },
    {
      question: '¿Por qué es tan barato? ¿Cuál es el truco?',
      answer: 'No hay truco. Este precio de S/ 25 es una oferta de lanzamiento exclusiva para los primeros 100 usuarios que confíen en Nexus. Queremos construir una comunidad sólida de casos de éxito antes de subir el precio a su valor real de S/ 497. Una vez que alcancemos el cupo, el precio aumentará permanentemente. Esta es tu única oportunidad de acceder con una suscripción anual a precio de lanzamiento. Después de los primeros 100, será tarde.'
    },
    {
      question: '¿El pago es seguro?',
      answer: 'Absolutamente. Utilizamos procesadores de pago certificados con encriptación de nivel bancario para proteger tu información financiera. Tu compra está 100% garantizada y segura. Además, si por alguna razón no estás satisfecho con Nexus, ofrecemos garantía de devolución de 7 días sin preguntas. Tu inversión está completamente protegida.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-12 sm:py-16 md:py-24 bg-[#F8F8F6]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 md:px-8">
        <div className="text-center mb-10 sm:mb-12 md:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#0A0A0A] mb-3 sm:mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Preguntas Frecuentes
          </h2>
          <p className="text-base sm:text-lg text-[#666]">
            Resolvemos todas tus dudas antes de que tomes la mejor decisión
          </p>
        </div>

        <div className="space-y-0">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className={`bg-white border-b border-[#E5E5E3] ${
                index === 0 ? 'rounded-t-xl sm:rounded-t-2xl' : ''
              } ${
                index === faqs.length - 1 ? 'rounded-b-xl sm:rounded-b-2xl border-b-0' : ''
              }`}
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-5 sm:px-8 md:px-10 py-5 sm:py-6 md:py-8 flex items-center justify-between cursor-pointer hover:bg-[#FAFAF8] transition-colors"
              >
                <h3 className="text-base sm:text-lg md:text-xl font-semibold text-[#0A0A0A] text-left pr-3 sm:pr-4">
                  {faq.question}
                </h3>
                <div className={`w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center flex-shrink-0 transition-colors ${
                  openIndex === index ? 'text-[#00D9FF]' : 'text-[#FF6B35]'
                }`}>
                  <i className={`${openIndex === index ? 'ri-subtract-line' : 'ri-add-line'} text-2xl sm:text-3xl font-bold`}></i>
                </div>
              </button>
              
              {openIndex === index && (
                <div className="px-5 sm:px-8 md:px-10 pb-5 sm:pb-6 md:pb-8 pt-0 animate-fadeIn">
                  <p className="text-sm sm:text-base text-[#555] leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
